import { useLinkLikeClick } from '../../../../../hooks'

export function useRentalPortalOverviewLink({ link }) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  function handleClickLink(event) {
    handleClick({ event, link })
  }

  function handleMouseDownLink(event) {
    handleMouseDown({ event, link })
  }

  return { handleClickLink, handleMouseDownLink }
}
